module.exports = __webpack_public_path__ + "static/etherscan-c5382ab2b43f2ae2f9289ce5ab29eceb.png";